import * as R from 'ramda';
import { EProductCollection } from '@gelato-api-ui/core/e-commerce/e-product-collection';

export const getProductCollectionIds = (collections: EProductCollection[]) =>
  collections ? R.pluck('id', collections) : [];
